import {
  GetInvoiceDetailItem,
  GetInvoiceDetailItemType,
} from '../../types/plansales/invoice/invoiceDetail';
import { getUtcDateDash } from '../utils/time';
import { NULL_TEXT } from '../../constants/common';
import { ReactElement } from 'react';
import { TextStyle } from '../../components/common/table/TableStyle';
import React from 'react';

/**
 * invoice detail page item list table > item 컬럼에 노출하는 텍스트
 * closet-next 와 싱크
 * @param type
 * @param planName
 */
export const renderInvoiceDetailItemTypeColumn = (
  type: GetInvoiceDetailItemType,
  planName: string,
) => {
  switch (type) {
    case GetInvoiceDetailItemType.CARRY_OVER_BALANCE:
    case GetInvoiceDetailItemType.DOWNGRADE_SUBSCRIPTION:
      return 'Carryover balance';
    case GetInvoiceDetailItemType.FIRST_SUBSCRIPTION:
    case GetInvoiceDetailItemType.RENEW_SUBSCRIPTION:
      return planName;
    case GetInvoiceDetailItemType.REFUND:
      return ''; // Refund 시에는 해당 컬럼을 비워준다
    default:
      return '';
  }
};

/**
 * invoice detail page item list table > desc 컬럼에 노출하는 텍스트
 * closet-next 와 싱크
 * @param item
 * @param planName
 */
export const renderInvoiceDetailItemDescriptionColumn = (
  item: GetInvoiceDetailItem,
  planName: string,
) => {
  const { startDate, endDate, type } = item;
  const fromDate = getUtcDateDash(startDate);
  const toDate = getUtcDateDash(endDate);

  switch (type) {
    case GetInvoiceDetailItemType.FIRST_SUBSCRIPTION: // Started the { planName } (2021-09-02 to 2021-09-06)
      return `Started the ${planName} Plan (${fromDate} to ${toDate})`;
    case GetInvoiceDetailItemType.RENEW_SUBSCRIPTION: // Renewed the { planName } (2021-09-07 to 2021-09-11)
      return `Renewed the  ${planName} Plan (${fromDate} to ${toDate})`;
    case GetInvoiceDetailItemType.CARRY_OVER_BALANCE:
      return NULL_TEXT; // 기획상 Carry Over Balance 는 NULL 표기
    case GetInvoiceDetailItemType.REFUND: // Canceled Payment
      return 'Canceled Payment';
    case GetInvoiceDetailItemType.DOWNGRADE_SUBSCRIPTION: // Settlement for the Addition Credits
      return 'Settlement for the Addition Credits';
    default:
      return '';
  }
};

export const renderInvoiceDetailItemPriceColumn = (value: number | null): string | ReactElement => {
  if (value === null) return '';
  const columnText = value.toFixed(2); // TODO: 추후에 통화 표기 받아서 달러/유로 붙여줘야함
  if (value < 0) {
    return <TextStyle style={{ color: 'red' }}>{columnText}</TextStyle>;
  }
  return columnText;
};
